const useDate = (date: number) => {
  const time = new Date(String(date).length === 10 ? date * 1000 : date)
  return {
    year: time.getFullYear() || '',
    month: ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1) || '',
    day: (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) || ''
  }
}
export { useDate }